import { render } from "./ArtistList.vue?vue&type=template&id=1133c7c4"
import script from "./ArtistList.vue?vue&type=script&lang=js"
export * from "./ArtistList.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./ArtistList.vue?vue&type=style&index=0&id=1133c7c4&module=true&lang=css"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__